<template>
  <div>
    <canvas id="drawing_canvas"></canvas>
    <audio
      v-show="false"
      :src="audioSrc"
      controls
      preload="auto"
      ref="audio-effect"
    />
  </div>
</template>
<script>
import { initDrawingCanvas, loop } from './Confetti'
import audioSrc from '@/assets/audio/confetti-bang.mp3'

export default {
  components: {
  },
  props: {
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      audioSrc,
    }
  },
  mounted() {
    const canvas = document.getElementById('drawing_canvas')
    const effectWrapper = document.getElementsByClassName('effect-wrapper')[0]
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    initDrawingCanvas(canvas, effectWrapper.offsetWidth, effectWrapper.offsetHeight)
    audioEffect.play().catch(() => {})
    audioEffect.addEventListener('play', () => {
      requestAnimationFrame(loop)
    })
    audioEffect.addEventListener('ended', () => {
      this.close()
    })
  },
  destroyed() {
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    audioEffect.pause()
  },
  methods: {

  },
}
</script>
<style scoped lang='scss'>
body {
  background-color: #fff;
  margin: 0;
  overflow: hidden;
}
#drawing_canvas {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
}
</style>
